/**
 * Route guard — redirects to login if not authenticated,
 * to MFA enrollment if MFA not set up, or to MFA verification
 * if MFA is enrolled but not yet verified this session.
 */
import { Navigate } from 'react-router-dom'
import { useAuth } from './AuthContext'

export default function ProtectedRoute({ children }) {
  const { isAuthenticated, loading, mfaEnrolled, mfaVerified, mfaChecked } = useAuth()

  if (loading || (isAuthenticated && !mfaChecked)) {
    return (
      <div className="min-h-screen bg-surface flex items-center justify-center">
        <div className="text-ink-muted">Loading...</div>
      </div>
    )
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />
  }

  // User is logged in but hasn't enrolled MFA yet — send to enrollment
  if (!mfaEnrolled) {
    return <Navigate to="/mfa/enroll" replace />
  }

  // User has MFA enrolled but hasn't verified this session — send to verify
  if (!mfaVerified) {
    return <Navigate to="/mfa/verify" replace />
  }

  return children
}
